<template>
  <div class="set-table-column">
    <Poptip
      trigger="click"
      placement="bottom-end"
      :width="popoverWidth"
      popper-class="set-table-columns-popper"
      @on-popper-hide="popoverHide"
      @on-popper-show="popoverShow"
    >
      <div class="trigger-mian">
        <Button v-if="buttonName" type="primary" icon="md-settings" class="mr10 trigger-btn">{{ buttonName }}</Button>
        <Icon v-else class="settingIcon mr10" type="md-settings" />
      </div>
      <div class="tabs_position" slot="content">
        <Tabs v-model="activeTab" @tab-click="tabSwitch">
          <TabPane
            v-for="(item, index) in moduleData"
            :label="item.tabLabel"
            :name="item.tabKey"
            :key="`${item.tabKey}-${index}`"
          >
            <div class="content">
              <CheckboxGroup
                v-if="!$common.isEmpty(item.options) && $common.isEmpty(item.group) && checkValObj[item.tabKey]"
                v-model="checkValObj[item.tabKey]"
                class="checkbox-group-main"
                :style="`grid-template-columns: repeat(${popoverColumns}, auto)`"
              >
                <Checkbox
                  v-for="(option, index) in item.options"
                  :key="`${option[item.replaceKey.value]}-${index}`"
                  :label="option[item.replaceKey.value]"
                  :disabled="(item.required && checkList && checkList.length == 1 && checkList.includes(option[item.replaceKey.value])) || disabled"
                >
                  <div class="checkboxWidth">{{ option[item.replaceKey.label] }}</div>
                </Checkbox>
              </CheckboxGroup>
              <div v-else-if="!$common.isEmpty(item.options) && !$common.isEmpty(item.group) && checkValObj[item.tabKey]">
                <div v-for="(gItem, gIndex) in item.group" :key="`${gItem.name}-${gIndex}`">
                  <div class="group-name-title">{{ gItem.name }}</div>
                  <CheckboxGroup
                    v-model="checkGroupValObj[`${item.tabKey}-${gItem.name}`]"
                    class="checkbox-group-main"
                    :style="`grid-template-columns: repeat(${popoverColumns}, auto)`"
                    @on-change="groupValDataChange($event, item.tabKey, gItem.name)"
                  >
                    <Checkbox
                      v-for="(option, index) in groupOptionsData[`${item.tabKey}-${gItem.name}`]"
                      :key="`${option[item.replaceKey.value]}-${index}`"
                      :label="option[item.replaceKey.value]"
                      :disabled="(item.required && checkList && checkList.length == 1 && checkList.includes(option[item.replaceKey.value])) || disabled"
                    >
                      <div class="checkboxWidth">{{ option[item.replaceKey.label] }}</div>
                    </Checkbox>
                  </CheckboxGroup>
                </div>
              </div>
              <div v-else class="emptys">
                暂无数据
              </div>
            </div>
          </TabPane>
        </Tabs>
        <Button
          v-if="activeInfo && activeInfo.options && activeInfo.options.length != 0"
          type="text"
          @click="resumeList"
          class="btn_position"
        >
          恢复默认
        </Button>
      </div>
    </Poptip>
  </div>
</template>

<script>

export default {
  name: "setTableColumn",
  props: {
    // 模块数据
    moduleData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 按钮名称
    buttonName: { type: String, default: '' },
    // 弹窗宽度
    popoverWidth: { type: Number, default: 580 },
    // 弹窗列数
    popoverColumns: { type: Number, default: 3 },
    // 是否禁用
    disabled: { type: Boolean, default: false },
    // 其他数据
    otherData: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      checkValObj: {},
      checkGroupValObj: {},
      oldCheckValObj: {},
      groupOptionsData: {},
      activeTab: '',
    }
  },
  watch: {
    moduleData: {
      immediate: true,
      deep: true,
      handler (val) {
        this.checkValObj = {};
        this.checkGroupValObj = {};
        let newVal = [];
        (val || []).forEach(item => {
          newVal = [];
          (item.options || []).forEach(op => {
            if (op[item.replaceKey.isCheck]) {
              newVal.push(op[item.replaceKey.value]);
            }
          });
          if (this.$common.isUndefined(this.checkValObj[item.tabKey])) {
            this.$set(this.checkValObj, item.tabKey, newVal);
          } else {
            this.checkValObj[item.tabKey] = newVal;
          }
          if (!this.$common.isEmpty(item.group)) {
            let groupList = [];
            let groupVal = [];
            (item.group || []).forEach(g => {
              groupVal = [];
              groupList = item.options.filter(f => f.warehouseType == g.warehouseType);
              (groupList || []).forEach(op => {
                if (op[item.replaceKey.isCheck]) {
                  groupVal.push(op[item.replaceKey.value]);
                }
              });
              this.$set(this.groupOptionsData, `${item.tabKey}-${g.name}`, groupList);
              if (this.$common.isUndefined(this.checkGroupValObj[`${item.tabKey}-${g.name}`])) {
                this.$set(this.checkGroupValObj, `${item.tabKey}-${g.name}`, groupVal);
              } else {
                this.checkGroupValObj[`${item.tabKey}-${g.name}`] = groupVal;
              }
            });
          }
        });
      }
    }
  },
  computed: {
    // 当前展示的标签内容
    activeInfo () {
      if (this.$common.isEmpty(this.moduleData)) return {};
      const info = this.moduleData.find(item => item.tabKey == this.activeTab);
      return info;
    },
    // 选中的数据列表
    checkList () {
      if (this.$common.isEmpty(this.checkValObj)) return [];
      let cList = [];
      Object.keys(this.checkValObj).forEach(key => {
        if (!this.$common.isEmpty(this.checkValObj[key])) {
          cList = [...cList, ...this.checkValObj[key]];
        }
      });
      return cList;
    }
  },
  created () {},
  methods: {
    // 显示时
    popoverShow () {
      this.oldCheckValObj = {};
      if (!this.$common.isEmpty(this.moduleData)) {
        this.activeTab = this.moduleData[0].tabKey;
        Object.keys(this.checkValObj).forEach(key => {
          if (this.$common.isUndefined(this.oldCheckValObj[key])) {
            this.$set(this.oldCheckValObj, key, this.$common.copy(this.checkValObj[key]));
          } else {
            this.oldCheckValObj[key] = this.$common.copy(this.checkValObj[key]);
          }
        });
      }
    },
    // 隐藏时
    popoverHide () {
      let backObj = {
        callBack: () => {}
      };
      let isIdentical = false;
      this.moduleData.forEach(item => {
        if (this.$common.isFunction(item.estimateChange)) {
          isIdentical = item.estimateChange(this.checkValObj[item.tabKey], this.oldCheckValObj[item.tabKey]);
        }
        backObj[item.tabKey] = {
          isChange: isIdentical,
          data: this.$common.copy(this.checkValObj[item.tabKey])
        }
      });
      this.$emit('updataColumn', backObj);
    },
    // 分组选项值改变时
    groupValDataChange (val, tabKey, name) {
      this.$nextTick(() => {
        this.checkValObj[tabKey] = this.$common.flat(Object.values(this.checkGroupValObj));
      });
    },
    // tab 切换时
    tabSwitch () {},
    // 恢复默认
    resumeList () {
      // 单个 tab 恢复默认
      // if (this.$common.isEmpty(this.activeInfo)) return;
      // if (this.$common.isFunction(this.activeInfo.renewData)) {
      //   if (this.$common.isEmpty(this.activeInfo.group)) {
      //     this.checkValObj[this.activeInfo.tabKey] = this.activeInfo.renewData();
      //   } else {
      //     const getVal = this.activeInfo.renewData();
      //     this.checkValObj[this.activeInfo.tabKey] = getVal.value;
      //     this.activeInfo.group.forEach(item => {
      //       this.checkGroupValObj[`${this.activeInfo.tabKey}-${item.name}`] = getVal[item.name];
      //     });
      //   }
      // } else {
      //   this.checkValObj[this.activeInfo.tabKey] = [];
      //   if (!this.$common.isEmpty(this.activeInfo.group)) {
      //     this.activeInfo.group.forEach(g => {
      //       this.checkGroupValObj[`${this.activeInfo.tabKey}-${g.name}`] = [];
      //     });
      //   }
      // }
      // 所有 tab 恢复默认
      this.moduleData.forEach(item => {
        if (!this.$common.isEmpty(item.renewData) && this.$common.isFunction(item.renewData)) {
          const getVal = item.renewData();
          if (this.$common.isEmpty(item.group)) {
            this.checkValObj[item.tabKey] = getVal;
          } else {
            this.checkValObj[item.tabKey] = getVal.value;
            item.group.forEach(g => {
              this.checkGroupValObj[`${item.tabKey}-${g.name}`] = getVal[g.name];
            });
          }
        } else {
          this.checkValObj[item.tabKey] = [];
          if (!this.$common.isEmpty(item.group)) {
            item.group.forEach(g => {
              this.checkGroupValObj[`${item.tabKey}-${g.name}`] = [];
            });
          }
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.group-name-title{
  padding: 10px 0;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.set-table-column{
  position: relative;
  :deep(.trigger-mian){
    .trigger-btn{
      i {
        font-size: 18px;
      }
    }
  }
  .settingIcon {
    font-size: 18px;
    cursor: pointer;
  }
}
.tabs_position {
  position: relative;
  .btn_position {
    position: absolute;
    top: 0;
    right: 0;
    color: #2E8CF0;
  }
  :deep(.content){
    .emptys {
      text-align: center;
      padding: 10px 0;
    }
    .checkbox-group-main{
      display: grid;
      gap: 5px 10px;
      max-height: 50vh;
      overflow: auto;
      .ivu-checkbox-wrapper {
        display: inline-flex;
        align-items: center;
        margin-right: 0;
      }
      .checkboxWidth {
        padding-left: 5px;
        white-space: normal;
        word-break: break-all;
      }
    }
  }
}
</style>
